import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { APOLLO_COMMERCE_CONTEXT } from '../../gql/constants';
import { PRODUCT_RECOMMENDATION_QUERY } from '../../gql/queries';
/**
 * Query one-graph for product recommendations
 * @param apolloClient ApolloClient; one-graph client
 * @param queryInputs ProductRecommendationInput; one-graph query parameters
 * @returns ApolloQueryResult
 */
export var fetchProductRecommendation = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var apolloClient, queryInputs, result;
    return _regeneratorRuntime.wrap(function _callee$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          apolloClient = _ref.apolloClient, queryInputs = _ref.queryInputs;
          _context2.prev = 1;
          _context2.next = 4;
          return apolloClient.query({
            query: PRODUCT_RECOMMENDATION_QUERY,
            variables: {
              input: queryInputs
            },
            context: _defineProperty({}, APOLLO_COMMERCE_CONTEXT, true)
          });
        case 4:
          result = _context2.sent;
          return _context2.abrupt("return", result);
        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](1);
          throw _context2.t0;
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee, null, [[1, 8]]);
  }));
  return function fetchProductRecommendation(_x) {
    return _ref2.apply(this, arguments);
  };
}();
export default fetchProductRecommendation;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/PRSUtils/fetchProductRecommendation.js
// module id = 1401
// module chunks = 11